namespace TabAurous.Sales {
    export namespace SalesQuotationItemsSelectService {
        export const baseUrl = 'Sales/SalesQuotationItemsSelect';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<SalesQuotationItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Sales/SalesQuotationItemsSelect/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>SalesQuotationItemsSelectService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
